import React, { Component } from "react";
import Header from "../../components/header/Header";
import TopButton from "../../components/topButton/TopButton";
import CoverLetter from "../../components/CoverLetter/CoverLetter"; // Ensure the path and capitalization are correct

import "./Opensource.css";

class Opensource extends Component {
  render() {
    return (
      <div className="opensource-main">
        <Header theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
        <CoverLetter />
      </div>
    );
  }
}

export default Opensource;
